/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import { WIRE_ACTION_PING, WIRE_ACTION_SUBSCRIBE, WIRE_ACTION_UNSUBSCRIBE } from './messageTypes';

export const buildPingMessage = ({ entityRef, token, apiKey }) => ({
  action: WIRE_ACTION_PING,
  entityRef,
  token,
  apiKey,
});

export const buildSubscribeMessage = ({ service, eventType, entityRef, token, apiKey, clientMessageId }) => ({
  action: WIRE_ACTION_SUBSCRIBE,
  service,
  eventType,
  entityRef,
  token,
  apiKey,
  clientMessageId,
});

export const buildUnsubscribeMessage = ({ service, eventType, entityRef, token, apiKey, clientMessageId }) => ({
  action: WIRE_ACTION_UNSUBSCRIBE,
  service,
  eventType,
  entityRef,
  token,
  apiKey,
  clientMessageId,
});
